var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FF6368"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8588_35181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4658 15.0133L22.6959 8.77797C23.1014 8.37239 23.1014 7.71661 22.6959 7.31102C22.2907 6.90544 21.6354 6.90544 21.2302 7.31102L14.9999 13.5464L8.76983 7.31102C8.36438 6.90544 7.70934 6.90544 7.30408 7.31102C6.89864 7.71661 6.89864 8.37239 7.30408 8.77797L13.5342 15.0133L7.30408 21.2487C6.89864 21.6543 6.89864 22.3101 7.30408 22.7157C7.50604 22.918 7.77159 23.0196 8.03695 23.0196C8.30232 23.0196 8.56768 22.918 8.76983 22.7157L14.9999 16.4803L21.2302 22.7157C21.4323 22.918 21.6977 23.0196 21.9631 23.0196C22.2284 23.0196 22.4938 22.918 22.6959 22.7157C23.1014 22.3101 23.1014 21.6543 22.6959 21.2487L16.4658 15.0133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8588_35181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close-red.bb2d89e3f0d4d182728dfe3a7ae3b2a2.svg";
export { ForwardRef as ReactComponent };